const deliveryUsersIds = ['1118', '1119'];
const deliveryOrgsIds = ['6eae1461-2403-4ab6-a3e4-7702733a4020'];
const appsJson = [
    {
        "name": "apps-card",
        "icon": "mdi-view-grid",
        "route": "/assets",
        "app_id": "001"
    },
    {
        "name": "delivery-app-card",
        "icon": "mdi-truck-delivery",
        "route": "/delivery",
        "app_id": "002"
     }
];
export default {
    deliveryUsersIds,
    deliveryOrgsIds,
    appsJson
};